<header class="navbar sticky-top flex-md-nowrap p-0 shadow">
    <a class="navbar-brand me-0 pe-3 fs-6" [routerLink]="['/dashboard']" style="padding-top: 7px; padding-bottom: 8px; width: 200px">
        <img src="./assets/img/taskradar.png" class="ms-2 me-2" style="height: 33px">
    </a>
    <button class="navbar-toggler position-absolute d-md-none collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
    <input class="form-control form-control-dark w-100 rounded-0 border-0 bg-white"
           type="text"
           placeholder="Suche nach Aufgabentitel"
           aria-label="Search"
           [(ngModel)]="searchString"
           (keyup.enter)="search()">
    <!--<div class="navbar-nav">
        <div class="nav-item text-nowrap text-white px-3">
            {{ accessService.user.firstname }} {{accessService.user.lastname}}
            <a class="nav-link px-3" href="" (click)="logout($event)">Abmelden</a>
        </div>
    </div>-->
</header>
